// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import ResumePage from './pages/ResumePage';
import MusicPage from './pages/MusicPage';
import ProjectsPage from './pages/ProjectsPage';
import ChangelogPage from './pages/ChangelogPage';
import BlogPage from './pages/BlogPage';
import AIToolsPage from './pages/AIToolsPage';
import LRCGeneratorPage from './pages/LRCGeneratorPage';
import TaskDefensePage from './pages/TaskDefensePage';
import MusicTestPage from './pages/MusicTestPage';
import WordGamePage from './pages/WordGamePage';
import LanguageLearningPage from './pages/LanguageLearningPage';
import CharleyMemoryPage, { charleyMemoryConfig } from './pages/CharleyMemory';
import CharleyMemoryAdminPage from './pages/CharleyMemory/CharleyMemoryAdminPage';
import CharleyMemoryQRCodePage from './pages/CharleyMemory/CharleyMemoryQRCodePage';
import GuestbookPage from './pages/CharleyMemory/Guestbook';
import CharleyMemoryTodosPage from './pages/CharleyMemory/CharleyMemoryTodosPage';
import CharleyMemoryDevTodosPage from './pages/CharleyMemory/CharleyMemoryDevTodosPage';

const App = () => {
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/music" element={<MusicPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:postId" element={<BlogPage />} />
        <Route path="/ai-tools" element={<AIToolsPage />} />
        <Route path="/lrc-generator" element={<LRCGeneratorPage />} />
        <Route path="/task-defense" element={<TaskDefensePage />} />
        <Route path="/music-test" element={<MusicTestPage />} />
        <Route path="/language-learning" element={<LanguageLearningPage />} />
        <Route path="/word-game" element={<WordGamePage />} />
        <Route path={charleyMemoryConfig.routePath} element={<CharleyMemoryPage />} />
        <Route path={`${charleyMemoryConfig.routePath}/admin`} element={<CharleyMemoryAdminPage />} />
        <Route path={`${charleyMemoryConfig.routePath}/guestbook`} element={<GuestbookPage />} />
        <Route path={`${charleyMemoryConfig.routePath}/todos`} element={<CharleyMemoryTodosPage />} />
        <Route path={`${charleyMemoryConfig.routePath}/dev-todos`} element={<CharleyMemoryDevTodosPage />} />
        <Route path={`${charleyMemoryConfig.routePath}/qr-code`} element={<CharleyMemoryQRCodePage />} />
      </Routes>
    </Router>
  );
};

export default App;